import { Controller } from "@hotwired/stimulus"

// "Record renewal wire" on Admin › Company › Payment › Builder Billing
// (Phelipe 2026-10-31): a yearly plan paid by wire got next year's money.
// Posts JSON and swaps this box with the server's new one (no reload).
export default class extends Controller {
  static targets = ["amount", "receivedOn", "reference", "button", "error"]
  static values = { url: String, companyId: String }

  async record() {
    this.buttonTarget.disabled = true
    this.errorTarget.classList.add("hidden")
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": this._csrf() },
        body: JSON.stringify({
          company_id: this.companyIdValue, amount: this.amountTarget.value,
          received_on: this.receivedOnTarget.value, reference: this.referenceTarget.value
        })
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(data.error || "Couldn't record the wire.")
      this._showToast(data.message || "Renewal recorded.")
      this.element.outerHTML = data.html
    } catch (error) {
      this.errorTarget.textContent = error.message
      this.errorTarget.classList.remove("hidden")
      this.buttonTarget.disabled = false
    }
  }

  _csrf() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }

  _showToast(message) {
    const el = document.createElement("div")
    el.className = "flash-toast-notice"
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.setAttribute("role", "alert")
    const msg = document.createElement("p")
    msg.className = "flex-1 text-sm"
    msg.textContent = message
    el.appendChild(msg)
    document.body.prepend(el)
  }
}
